var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._b({staticClass:"pa-2 ml-auto btn-download",attrs:{"type":"button","text":"","icon":"","color":"#c3e5ff","loading":_vm.loading,"title":"Скачать"},on:{"click":_vm.downloadCustomFile}},'v-btn',_vm.$attrs,false),[_vm._t("default",function(){return [_c('SvgFileDownloaded')]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }